import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";
import { upsertAttribute } from "../thunks/upsertAttribute";
import { setFetchState } from "../attributeDataReducer";
import { Attribute } from "../types";

export const useAttributeUpsert = () => {
	const fetchState = useSelector<StoreType, FetchStateType>(
		store => store.data.listing.attributes.fetchState
	);

	const dispatch = useDispatch();
	const dispatchUpsert = React.useCallback(
		(item: Attribute) => dispatch(upsertAttribute(item)),
		[dispatch]
	);

	React.useEffect(() => {
		dispatch(setFetchState({ type: "not-started" }))
	}, [dispatch])

	return [fetchState, dispatchUpsert] as [typeof fetchState, typeof dispatchUpsert]
};
